import Axios from "../../configs/axios.config";

export const createDepartment = (data) =>
  Axios.post(`/workspace/department`, data).then(
    (response) => response.data.data
  );
export const updateDepartment = (data, id) =>
  Axios.put(`/workspace/department/${id}`, data).then(
    (response) => response.data.data
  );
export const getDepartmentList = (data) =>
  Axios.get("/workspace/department", { params: data }).then(
    (response) => response.data
  );
export const getDepartmentDetail = (id) =>
  Axios.get(`/workspace/department/${id}`).then(
    (response) => response.data.data
  );
export const deleteDepartment = (id) =>
  Axios.delete(`/workspace/department/${id}`);
